import { render, staticRenderFns } from "./gradeConversionTable.vue?vue&type=template&id=23964d1c"
import script from "./gradeConversionTable.vue?vue&type=script&lang=js"
export * from "./gradeConversionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports